import { initializeInfiniteGrid } from './infinitegrid'

window.addEventListener('turbolinks:load', () => {
  const gridElement = document.getElementById('infinitegrid-publications')
  if (!gridElement) return

  initializeInfiniteGrid(gridElement)
})
